export default __webpack_public_path__ + "static/media/json-icon.e6f077a7.svg";